import { actions } from 'Data/ReduxViewModels/Authentication';
import { hasValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import classNames from 'classnames';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, Field, Message, PasswordInput, TextInput } from '../../Core';
import { ListFieldSection } from '../../Layout';
import ChangePassword from '../../User/ChangePassword';
import './Login.scss';

const Login: React.FC = () => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const isAuthenticating = useSelector((state) => state.authentication.isAuthenticating);
  const statusMessage = useSelector((state) => state.authentication.statusMessage);
  const platformVersion = useSelector((state) => state.authentication.platformVersion);
  const mustChangePassword = useSelector((state) => !!state.authentication.mustChangeMessage);
  const authSettings = useSelector((state) => state.authentication.authSettings, deepEquals);
  const isFrame = useSelector(() => window.qest.isFrame);
  const entraEnabled = authSettings?.isEntraEnabled ?? false;

  const dispatch = useDispatch();
  const handleLogin = (e: any) => {
    e.preventDefault();
    dispatch(actions.postLogin({ username, password }));
  };
  const handleOAuthLogin = (e: any) => {
    e.preventDefault();
    dispatch(actions.postEntraLogin());
  };
  const possibleMisconfiguration =
    process.env.REACT_APP_AUTOLOGIN === 'true' &&
    (!process.env.REACT_APP_AUTH_USERNAME || !process.env.REACT_APP_AUTH_PASSWORD);
  const headerClassNames = classNames('Login-Header', { 'Login-Header-Full': !isFrame });
  return (
    <div className={'Login'}>
      {possibleMisconfiguration && (
        <div>You appear to be using developer automatic login but have missing credentials, check your env config.</div>
      )}
      {mustChangePassword && (
        <Dialog visible={true} onClose={() => dispatch(actions.clearChangePassword())} title="Password Change Required">
          <ChangePassword onSuccess={false} loginName={username} wide />
        </Dialog>
      )}

      <header className={headerClassNames}>
        {!isFrame && (
          <h1 className="Login-Logo">
            <span className="Login-Product"></span>
          </h1>
        )}
      </header>
      {!entraEnabled && (
        <form onSubmit={(e) => handleLogin(e)} className="LoginPanel">
          <div className="LoginPanel-Content">
            <ListFieldSection single wide>
              <Field
                input={<TextInput />}
                label="Username"
                onChange={(e: any) => setUserName(e.target.value)}
                placeholder="Enter username"
                value={username}
                autoFocus
                disabled={isAuthenticating}
              />
              <div className="LoginPassword">
                <Field
                  input={<PasswordInput />}
                  label="Password"
                  messages={[{ message: statusMessage?.message, severity: statusMessage?.severity }]}
                  onChange={(e: any) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  value={password}
                  disabled={isAuthenticating}
                  severity="error"
                />
              </div>
              <Button loading={isAuthenticating} onClick={(e) => handleLogin(e)} primary>
                Log In
              </Button>
            </ListFieldSection>
          </div>
        </form>
      )}
      {entraEnabled && (
        <div className="LoginPanel-Content">
          <ListFieldSection wide>
            <Button
              onClick={(e) => handleOAuthLogin(e)}
              disabled={!hasValue(authSettings?.clientId) || !hasValue(authSettings?.tenantId)}
              loading={isAuthenticating}
              error
            >
              Log in with Microsoft Entra
            </Button>
            {statusMessage && <Message {...statusMessage} />}
          </ListFieldSection>
        </div>
      )}
      {!window.qest.isFrame && (
        <span className="Login-VersionLabel">
          &copy; Spectra QEST {new Date().getFullYear()} &bull; QEST Platform {platformVersion ?? '(loading...)'}
        </span>
      )}
    </div>
  );
};

export default Login;
